import { graphql } from "gatsby";
import React from "react";
import SectionArticleOrEventCards from "../../../containers/sections/SectionArticleOrEventCards";
import { mapContentUnionToSignPostCardProps } from "../../../utils/mappers";

export interface ParagraphContentReferenceArticlesProps {
	heading?: string;
	jumpLinksTitle?: string;
	htmlText?: string;
	items: DogsTrust.SignPostCardProps[];
}

export const getParagraphContentReferenceArticlesProps = ({
	field_heading,
	field_jump_links_title,
	field_text,
	relationships: { field_content },
}: Queries.ParagraphContentReferenceArticlesDataFragment): ParagraphContentReferenceArticlesProps => ({
	heading: field_heading,
	jumpLinksTitle: field_jump_links_title,
	htmlText: field_text?.value,
	items: field_content.map(mapContentUnionToSignPostCardProps),
});
export const ParagraphContentReferenceArticles: React.FC<
	ParagraphContentReferenceArticlesProps
> = ({ heading, jumpLinksTitle, htmlText, items }) => {
	return (
		<SectionArticleOrEventCards
			items={items}
			bodyHtmlText={htmlText}
			title={heading}
			jumpLinksTitle={jumpLinksTitle}
			withoutMargins={true}
			forceFlatCards={false}
		/>
	);
};

export default ParagraphContentReferenceArticles;

export const fragment = graphql`
    fragment ParagraphContentReferenceArticlesData on paragraph__content_reference_articles {
        __typename
        id
        field_heading
        field_jump_links_title
        field_text {
            value
        }
        relationships {
            field_content {
                ...ContentUnionData
            }
        }
    }

    fragment ContentUnionData on ContentUnion {
        __typename
        ...ArticleContentData
        ...AppealContentData
        ...PageContentData
        ...BreedContentData
        ...EventContentData
        ...CentreContentData
        ...CentreArticleContentData
        ...CharityShopContentData
        ...LandingPageContentData
        ...TopicContentData
        ...OurStoryContentData
        ...StaticInternalPageReferenceContentData
    }

    fragment ArticleContentData on node__article {
        __typename
        title
        path {
            alias
        }
        field_node_weight
        field_short_description
        field_short_link_text
        drupal_id

        relationships {
            field_category_type {
                name
            }
            field_icon {
                field_media_image {
                    uri
                    alt
                }
            }
            field_featured_image {
                field_media_image {
                    uri
                    alt
                    title
                    width
                    height
                }
            }
        }
    }
    fragment AppealContentData on node__appeal {
        __typename
        title
        path {
            alias
        }
        field_short_description
        field_short_link_text

        relationships {
            field_featured_image {
                field_media_image {
                    uri
                    alt
                    title
                    width
                    height
                }
            }
        }
    }
    fragment PageContentData on node__page {
        __typename
        path {
            alias
        }
        title
        field_subtitle
        field_intro_text {
            processed
            value
        }
        relationships {
            field_images {
                field_media_image {
                    uri
                    alt
                }
            }
        }
    }
    fragment BreedContentData on node__breed {
        __typename
        title
        path {
            alias
        }
        field_intro_copy
        relationships {
            field_featured_image {
                field_media_image {
                    uri
                    alt
                }
            }
        }
    }
    fragment EventContentData on node__event {
        __typename
        title
        path {
            alias
        }
        field_event_date
        relationships {
            field_featured_image {
                field_media_image {
                    uri
                    alt
                }
            }
        }
    }
    fragment CentreContentData on node__centre {
        __typename
        title
        path {
            alias
        }
        field_centre_lead_paragraph {
            value
        }
        relationships {
            field_centre_images {
                field_media_image {
                    uri
                    alt
                }
            }
        }
    }
    fragment CentreArticleContentData on node__centre_article {
        __typename
        title
        path {
            alias
        }
        field_centre_article_intro_text
        field_short_link_text
        relationships {
            field_hero_image {
                field_media_image {
                    uri
                    alt
                }
            }
        }
    }
    fragment CharityShopContentData on node__charity_shop {
        __typename
        title
        path {
            alias
        }
        field_shop_intro_header_text
        relationships {
            field_shop_images {
                field_media_image {
                    uri
                    alt
                }
            }
        }
    }
    fragment LandingPageContentData on node__landing_page {
        __typename
        path {
            alias
        }
        title
        drupal_id
        field_short_link_text
        field_intro_text {
            processed
            value
        }
        relationships {
            field_images {
                field_media_image {
                    uri
                    alt
                }
            }
            field_icon {
                field_media_image {
                    uri
                    alt
                }
            }
        }
    }
    fragment TopicContentData on node__topic {
        __typename
        path {
            alias
        }
        title
        drupal_id
        field_short_description
        field_short_link_text
        relationships {
            field_featured_image {
                field_media_image {
                    alt
                    title
                    width
                    height
                    uri
                }
            }
            field_icon {
                field_media_image {
                    uri
                    alt
                }
            }
            field_parent {
                name
            }
        }
    }
    fragment OurStoryContentData on node__our_story {
        __typename
        title
        path {
            alias
        }
        field_node_weight
        field_short_description
        field_short_link_text

        relationships {
            field_category_type {
                name
            }
            field_featured_image {
                field_media_image {
                    uri
                    alt
                    title
                    width
                    height
                }
            }
        }
    }
    fragment StaticInternalPageReferenceContentData on node__static_internal_page_reference {
        __typename
        title
        field_summary
        field_link {
            title
            uri
        }
        field_node_weight
        relationships {
            field_image {
                field_media_image {
                    alt
                    uri
                }
            }
            field_icon {
                field_media_image {
                    uri
                    alt
                }
            }
        }
    }
`;
